var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Link, Tag } from '@philips-internal/oswald-ui-components/lib/components';
import './pseudonym-suggestion-card-item.css';
import PseudonymSuggestionCardItemAPI from './pseudonym-suggestion-card-api';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { ScheduleType } from './pseudonym-suggestion-card-item-type';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { bool, eventListener, func, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ReactComponent as CalendarGray75SVG } from '../../assets/images/global/Calendar-DLS.svg';
import { ReactComponent as LocationSVG } from '../../assets/images/global/location.svg';
import { DateFormatterUtil } from '../../util/';
let PseudonymSuggestionCardItem = class PseudonymSuggestionCardItem extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, isBlocked } = this.props;
            if (isFunction(onClick) && isBlocked !== true) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
        this.getCardTitle = (title, type) => {
            const expressionScheduleType = this.getExpressionScheduleType(type);
            if (title) {
                return expressionScheduleType;
            }
            return expressionScheduleType.concat(' ').concat(title);
        };
        this.getExpressionScheduleType = (scheduleType) => {
            switch (scheduleType) {
                case ScheduleType.CONSULTATION:
                    return MessageService.translate('schedule-type.consultation');
                case ScheduleType.EXAM:
                    return MessageService.translate('schedule-type.exam');
                case ScheduleType.SERVICE:
                    return MessageService.translate('schedule-type.service');
                default:
                    return '';
            }
        };
    }
    static { this.propTypes = {
        callToWaitlistModal: func,
        isSelected: bool,
        isShowPrice: bool,
        onClick: eventListener,
        price: string,
        removeItemFromWaitingList: func,
        removeItemSelected: func,
        selectedDate: string,
        showWaitingListModal: func,
        title: string,
        type: string,
    }; }
    callWaitingListModal() {
        const { cdMedico = '', cdEspecialidade = '', type, nrSeqProcInterno, dsProcInterno, callToWaitlistModal = null, title, nrSeqAgeintItem, nrSeqAgeint } = this.props;
        if (callToWaitlistModal == null) {
            return;
        }
        const physician = { cdPessoaFisica: cdMedico, nmPessoaFisica: cdMedico ? title : '' };
        const scheduleType = [];
        const examScheduleList = [];
        const consultScheduleList = [];
        switch (type) {
            case 'E':
                scheduleType.push({ id: 2, value: 'schedule-type.exam' });
                examScheduleList.push({
                    exam: {
                        dsImagemBase64: this.state.image,
                        dsProcInterno: dsProcInterno,
                        dsTipoExame: type,
                        nrSeqAgeintItem: nrSeqAgeintItem,
                        nrSeqProcInterno: Number(nrSeqProcInterno),
                    }
                });
                break;
            case 'C':
                scheduleType.push({ id: 1, value: 'schedule-type.consultation' });
                consultScheduleList.push({
                    nrSeqAgeintItem: nrSeqAgeintItem,
                    physician: {
                        cdPessoaFisica: cdMedico,
                        nmPessoaFisica: ''
                    },
                    specialityData: {
                        cdEspecialidade: Number(cdEspecialidade) || undefined,
                    },
                });
                break;
            default:
                break;
        }
        callToWaitlistModal({ consultScheduleList, examScheduleList, nrSeqAgeint, physician, scheduleType });
    }
    removeItemFromWaitingList(nrSeqAgeintItem) {
        const removeItem = this.props.removeItemFromWaitingList;
        if (removeItem != null) {
            removeItem(nrSeqAgeintItem);
        }
    }
    removeItemSelected(suggestionGroupId) {
        const removeItem = this.props.removeItemSelected;
        if (removeItem != null) {
            removeItem(suggestionGroupId);
        }
    }
    openWaitListModal() {
        const { callToWaitlistModal, showWaitingListModal, nrSeqAgeintItem } = this.props;
        if (callToWaitlistModal) {
            this.callWaitingListModal();
        }
        else if (showWaitingListModal) {
            showWaitingListModal(nrSeqAgeintItem);
        }
    }
    renderRemoveItemTag() {
        const { isShowPrice, suggestionGroupId, startDate, price } = this.props;
        if (!startDate) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: 'pseudonym-suggestion-footer-link' },
            React.createElement("div", { className: "pseudonym-suggestion-footer-price-tag" }, isShowPrice ? React.createElement("span", null, price) : React.createElement(React.Fragment, null)),
            React.createElement("div", { className: "pseudonym-suggestion-footer-link-remove-item-selected" },
                React.createElement(Link, { value: MessageService.translate('patient.cancel'), onClick: () => this.removeItemSelected(suggestionGroupId.toString()) }))));
    }
    renderWaitingListItemTag() {
        const { isWaitingListItem, nrSeqAgeintItem } = this.props;
        if (!isWaitingListItem) {
            return (React.createElement("div", { className: 'pseudonym-suggestion-footer-single-link' },
                React.createElement(Link, { value: MessageService.translate('patient.button-label.enter-the-waiting-list'), onClick: () => this.openWaitListModal() })));
        }
        return (React.createElement("div", { className: 'pseudonym-suggestion-footer-link' },
            React.createElement(Tag, { value: MessageService.translate('patient.label.modal-scheduling-waiting-list'), formatters: {}, color: 'safety-orange' }),
            React.createElement(Link, { value: MessageService.translate('patient.cancel'), onClick: () => this.removeItemFromWaitingList(nrSeqAgeintItem) })));
    }
    renderCardSuggestionFooter() {
        const { isItemFromReschedule, isEnabledToScheduleWaitingList, hasSchedulingTimes } = this.props;
        if (isItemFromReschedule || hasSchedulingTimes || !isEnabledToScheduleWaitingList) {
            return this.renderRemoveItemTag();
        }
        return this.renderWaitingListItemTag();
    }
    renderSuggestionCardItemDate() {
        const { startDate } = this.props;
        if (!startDate) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: "calendar" },
            React.createElement(CalendarGray75SVG, null),
            React.createElement("span", null, DateFormatterUtil.short(startDate))));
    }
    renderSuggestionCardItemLocation() {
        const { dsEstablishment } = this.props;
        if (!dsEstablishment) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: "location" },
            React.createElement(LocationSVG, null),
            React.createElement("span", null, dsEstablishment)));
    }
    renderSuggestionCardItemInfo() {
        const { customMessage, isItemFromReschedule, isEnabledToScheduleWaitingList, hasSchedulingTimes, isBlocked } = this.props;
        if (isBlocked) {
            return (React.createElement("div", { className: "blocked-list" },
                React.createElement("span", null, customMessage ? customMessage : MessageService.translate('tws.label-blocked-by-health-insurance'))));
        }
        if (isItemFromReschedule || hasSchedulingTimes || !isEnabledToScheduleWaitingList) {
            return (React.createElement(React.Fragment, null,
                this.renderSuggestionCardItemDate(),
                this.renderSuggestionCardItemLocation()));
        }
        return (React.createElement("div", { className: "waiting-list" },
            React.createElement("span", null, 'Não existe horário disponível para essa agenda.')));
    }
    renderDefaultCard() {
        const { title, type } = this.props;
        const descriptionAvatar = title ?? '-';
        const titleAvatar = this.getCardTitle(title, type);
        return (React.createElement(React.Fragment, null,
            React.createElement(Avatar, { title: titleAvatar, description: descriptionAvatar, size: Size.SMALL, className: 'avatar', hideImage: true }),
            React.createElement("div", { className: "info" }, this.renderSuggestionCardItemInfo())));
    }
    getClassName() {
        const { isSelected, isBlocked } = this.props;
        if (isBlocked) {
            return 'pseudonym-suggestion-card-item__blocked';
        }
        return isSelected ? 'pseudonym-suggestion-card-item__selected' : 'pseudonym-suggestion-card-item';
    }
    render() {
        return (React.createElement(Card, { selectionType: SelectionType.SINGLE, onClick: this.handleClick, className: this.getClassName(), width: 4, transparent: false, uuid: generateUUID() },
            React.createElement("div", { className: 'pseudonym-suggestion-card-content' },
                React.createElement("div", { className: 'pseudonym-suggestion-card-title-content' }, this.renderDefaultCard()),
                React.createElement("div", { className: 'pseudonym-suggestion-card-footer' }, this.renderCardSuggestionFooter()))));
    }
};
PseudonymSuggestionCardItem = __decorate([
    AwesomeComponent({ api: PseudonymSuggestionCardItemAPI, type: ComponentType.DATA_DISPLAY })
], PseudonymSuggestionCardItem);
export default PseudonymSuggestionCardItem;
//# sourceMappingURL=pseudonym-suggestion-card-item.js.map